import { render, staticRenderFns } from "./SideMenuFilterEmpty.vue?vue&type=template&id=9720ed24&scoped=true&"
import script from "./SideMenuFilterEmpty.vue?vue&type=script&lang=js&"
export * from "./SideMenuFilterEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuFilterEmpty.vue?vue&type=style&index=0&id=9720ed24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9720ed24",
  null
  
)

export default component.exports